import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { featuredProjects } from "../data/mock";

export default function FeaturedProjects() {
  return (
    <section id="projects" className="relative py-24 lg:py-32 bg-[#08080a]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-12 reveal">
          <div>
            <div className="text-[11px] uppercase tracking-[0.3em] text-amber-accent mb-4">Featured Projects</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] max-w-2xl">
              Engineering the landmarks <span className="text-amber-accent">behind everyday life.</span>
            </h2>
          </div>
          <Link to="/projects" className="hidden sm:inline-flex items-center gap-2 text-sm font-medium text-white/80 hover:text-white link-shimmer">
            View all projects <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {featuredProjects.map((p, idx) => (
            <Link
              key={p.id}
              to={`/projects/${p.id}`}
              className="proj-card reveal relative block rounded-xl overflow-hidden bg-[#101014] border border-white/5 group"
              style={{ transitionDelay: `${idx * 80}ms` }}
            >
              <div className="relative w-full overflow-hidden aspect-[16/10]">
                <img src={p.image} alt={p.title} className="w-full h-full object-cover" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
                <div className="absolute top-4 left-4 flex items-center gap-2">
                  <span className="px-2.5 py-1 rounded-full bg-[#F5D000] text-black text-[10px] font-semibold uppercase tracking-wider">
                    {p.category}
                  </span>
                  <span className="px-2.5 py-1 rounded-full bg-black/50 backdrop-blur border border-white/15 text-white text-[10px] font-semibold uppercase tracking-wider">
                    {p.year}
                  </span>
                </div>
                <div className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/10 backdrop-blur border border-white/15 flex items-center justify-center text-white transition-all duration-500 group-hover:bg-[#F5D000] group-hover:text-black group-hover:rotate-45">
                  <ArrowUpRight className="w-4 h-4" />
                </div>
              </div>
              <div className="p-6">
                <div className="text-[11px] uppercase tracking-[0.22em] text-white/55 mb-2">{p.subtitle}</div>
                <h3 className="font-display text-2xl font-bold mb-2 text-white group-hover:text-[#F5D000] transition-colors">
                  {p.title}
                </h3>
                <p className="text-sm text-white/65 leading-relaxed line-clamp-3">{p.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
